import {LocalizedString} from "components/commons/Children";
import {Box} from "./commons/Box";
import {BarSpinner} from "./BarSpinner";
import {Space} from "./commons/Space";
import {Body} from "./commons/text/Body";

type Props = {
    message?: LocalizedString;
    ariaLabelMessage?: LocalizedString;
    basis?: string | number;
}

export default function Loader({message, ariaLabelMessage, basis}: Props) {
    return (
        <Box
            grow
            basis={basis ? basis : "100%"}
            vAlignContent="center"
            hAlignContent="center"
            column
            aria-label={ariaLabelMessage}
            style={{minHeight: "100px"}}
        >
            <div className="bar-spinner-wrapper">
                <BarSpinner/>
                {message &&
                    <>
                        <Space units={2}/>
                        <Body size="medium" weight="regular" align="center">
                            {message}
                        </Body>
                    </>}
            </div>
        </Box>
);
}